import React, { Component } from "react";
import {
    Button,
    Popover,
    PopoverBody,
} from "reactstrap";
import ButtonMenu from "./ButtonMenu";

class OptionMenu extends Component {

    render() {

        const {
            idOpcion,
            isOpen,
            opciones = []
        } = this.props;

        return (
            <div className="flex flex-row">
                <Button
                    id={idOpcion}
                    className="btn-ellipsis"
                    onClick={() => { this.props.toggleUserCardPopover(idOpcion) }}
                >
                    <i className="fa fa-ellipsis-v"></i>
                </Button>
                <Popover
                    key={`Pop-${idOpcion}`}
                    placement='bottom-end'
                    isOpen={isOpen}
                    target={idOpcion}
                    className='p-0 border-0'
                    style={{ minWidth: 200 }}>
                    <PopoverBody className='p-0 border-light'>
                        {opciones.map((opc) => (
                            <ButtonMenu
                                opcion={opc}
                                dataProps={this.props}
                            />
                        ))}
                    </PopoverBody>
                </Popover>
            </div>
        );
    }
}

export default OptionMenu;